// @flow

import ko from 'rgs-knockout';
import Q from 'q';
import {
	fetchEntrypoints,
	createCssBundleList,
	createJsBundleList,
	GlobalEventEmitterHandler,
} from './utils';
import type { ReactComponentParams } from './model';

const COMPONENT_NAME = 'reactComponent';
const PREFIX = {
	RENDER: 'render-',
	UPDATE: 'update-',
};

ko.bindingHandlers[COMPONENT_NAME] = {
	init: function (el, valueAccessor, allBindings) {
		const component: ReactComponentParams = ko.unwrap(valueAccessor());
		const model = ko.toJS(allBindings.get('model'));

		fetchEntrypoints(component.entrypoints)
			.then((data: any) => {
				Promise.all(createCssBundleList(
					data,
					component.name,
				));

				Promise.all(createJsBundleList(
					data,
					component.name,
					component.eventEmitterName,
					`${PREFIX.RENDER}${component.name}`,
					model,
				));
			});

		return { controlsDescendantBindings: true };
	},
	update: async function (el, valueAccessor, allBindings) {
		ko.unwrap(allBindings.get('model'));
		const component = ko.unwrap(valueAccessor());
		const model = ko.toJS(allBindings.get('model'));

		await Q.delay(component.updateDelay || 0);

		GlobalEventEmitterHandler.emit(
			component.eventEmitterName,
			`${PREFIX.UPDATE}${component.name}`,
			model,
		);
	},
};

ko.virtualElements.allowedBindings[COMPONENT_NAME] = true;